import React, { useState, useEffect } from "react";
import { RACE_DATE } from "../data/constants";

export default function Countdown() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const raceDay = new Date(RACE_DATE.getFullYear(), RACE_DATE.getMonth(), RACE_DATE.getDate());
  const diffMs = raceDay - today;
  const daysLeft = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  let message, color, bgColor;
  if (daysLeft > 1) {
    message = `Faltan ${daysLeft} días para la carrera`;
    color = "#0369A1";
    bgColor = "#E0F2FE";
  } else if (daysLeft === 1) {
    message = "¡Mañana es la carrera!";
    color = "#B45309";
    bgColor = "#FEF3C7";
  } else if (daysLeft === 0) {
    message = "¡HOY ES EL DÍA! 🏁";
    color = "#9F1239";
    bgColor = "#FFE4E6";
  } else {
    message = "¡Carrera completada!";
    color = "#065F46";
    bgColor = "#D1FAE5";
  }

  return (
    <div
      style={{
        textAlign: "center",
        padding: "12px 16px",
        borderRadius: 12,
        background: bgColor,
        marginBottom: 16,
        fontSize: 15,
        fontWeight: 700,
        color: color,
        letterSpacing: 0.5,
      }}
    >
      {message}
    </div>
  );
}
